import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=0c47cf84&scoped=true&"
import script from "./advertisement.vue?vue&type=script&lang=ts&"
export * from "./advertisement.vue?vue&type=script&lang=ts&"
import style0 from "./advertisement.vue?vue&type=style&index=0&id=0c47cf84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c47cf84",
  null
  
)

export default component.exports